var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.481,
    height: 37.5,
    viewBox: "0 0 37.481 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insta-bold",
    transform: "translate(-3.769 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10535",
    "data-name": "Path 10535",
    d: "M14.644,3.75H30.356c6.825,0,10.894,4.069,10.894,10.894V30.337c0,6.844-4.069,10.913-10.894,10.913H14.663c-6.825,0-10.894-4.069-10.894-10.894V14.644C3.75,7.819,7.819,3.75,14.644,3.75Z",
    fill: "#fd792f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10536",
    "data-name": "Path 10536",
    d: "M22.5,29.775A7.275,7.275,0,1,1,29.775,22.5,7.275,7.275,0,0,1,22.5,29.775Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10537",
    "data-name": "Path 10537",
    d: "M13.125,14.063a1.855,1.855,0,0,0,1.331-.544,2.163,2.163,0,0,0,.394-.619,1.767,1.767,0,0,0,0-1.425,1.934,1.934,0,0,0-.394-.619,1.872,1.872,0,0,0-1.687-.506,1.129,1.129,0,0,0-.356.113,1.42,1.42,0,0,0-.338.169,2.962,2.962,0,0,0-.281.225,1.935,1.935,0,0,0-.394.619,1.767,1.767,0,0,0,0,1.425,2.165,2.165,0,0,0,.394.619,2.165,2.165,0,0,0,.619.394A1.868,1.868,0,0,0,13.125,14.063Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaBold);
export default __webpack_public_path__ + "static/media/insta-bold.3154513c6299499b2a56d2fd948e763a.svg";
export { ForwardRef as ReactComponent };